module.exports = __webpack_public_path__ + "static/logo-gradient-d1f16d515835a7102d42657c33fb2925.png";